import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
    level = '1',
    action = '',
    comment = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpiAudit.flowEdited, {
        projId,
        level: Number.parseInt(level),
        action,
        comment,
    }, options);
    if (error) return { error, status };
    return content || { };
};
